import { render } from "./Connect.vue?vue&type=template&id=6cbda218&ts=true"
import script from "./Connect.vue?vue&type=script&lang=ts"
export * from "./Connect.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__